import {inlineError} from '@s-ui/decorators'
import {Service} from '@s-ui/domain'

/**
 * @implements Service
 */
export class DiscardDraftService extends Service {
  constructor({cookieRepository, httpRepository}) {
    super()

    this._cookieRepository = cookieRepository
    this._httpRepository = httpRepository
  }

  /**
   * @return {Promise<DraftEntity, Error>} returns the draft entity
   */
  @inlineError
  async execute({userEntity, ...draft}) {
    const discardDraft = userEntity ? this._httpRepository.discardDraft : this._cookieRepository.discardAnonymousDraft
    const [discardError, discardResponse] = await discardDraft(draft)

    if (discardError) {
      return Promise.reject(discardError)
    }

    return discardResponse
  }
}
